import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

import { SharedModule } from "src/app/shared/shared.module";
import { AcompanhamentoBatchPesquisaComponent } from "./acompanhamento-batch-pesquisa/acompanhamento-batch-pesquisa.component";
import { AcompanhamentoBatchListagemComponent } from "./acompanhamento-batch-listagem/acompanhamento-batch-listagem.component";
import { AcompanhamentoBatchDetalheComponent } from "./acompanhamento-batch-detalhe/acompanhamento-batch-detalhe.component";
import { AcompanhamentoBatchRoutingModule } from "./acompanhamento-batch-routing.module";

@NgModule({
    declarations:[
        AcompanhamentoBatchPesquisaComponent,
        AcompanhamentoBatchListagemComponent,
        AcompanhamentoBatchDetalheComponent,
    ],
    exports: [
      AcompanhamentoBatchPesquisaComponent,
      AcompanhamentoBatchListagemComponent,
      AcompanhamentoBatchDetalheComponent,
    ],
    imports:[
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        AcompanhamentoBatchRoutingModule,
    ],
    providers:[DatePipe]

})
export class AcompanhamentoBatchModule{}